import { MerchantEffects } from './merchant.effects';
import { UserEffects } from './user.effects';

export default [
  MerchantEffects,
  UserEffects,
];